module.exports = __webpack_public_path__ + "img/pro_three_3.f79ddbb7.jpg";